import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/index';
import HelloWorldPage from './pages/hello-world';
import HomeLandingPage from './pages/home';

// Lazy load the Theatre page to enable code splitting
const TheatrePage = React.lazy(() => import('./pages/theatre'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeLandingPage />} />
        <Route path="/app" element={<HomePage />} />
        <Route path="/hello-world" element={<HelloWorldPage />} />
        <Route
          path="/theatre"
          element={
            <Suspense fallback={
              <div style={{
                width: "100vw",
                height: "100vh",
                background: "black",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                fontFamily: "Arial, sans-serif"
              }}>
                Loading Theatre Mode...
              </div>
            }>
              <TheatrePage />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default App; 